export default __webpack_public_path__ + "static/customize-universal-checkout-79026302bee68ccfc5fdc7cd5ecd3bf1.png";